import { render, staticRenderFns } from "./ComplaintCategoryModal.vue?vue&type=template&id=5d856f01&scoped=true&"
import script from "./ComplaintCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ComplaintCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintCategoryModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ComplaintCategoryModal.vue?vue&type=style&index=1&id=5d856f01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d856f01",
  null
  
)

export default component.exports